import { useEffect, useState } from "react";

const useLoadHubspotForms = (): boolean => {
  const [isHubspotFormsLoaded, setHubspotFormsLoaded] = useState(false);
  const scriptUrl = "https://js.hsforms.net/forms/embed/5347146.js";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => setHubspotFormsLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return isHubspotFormsLoaded;
};

export default useLoadHubspotForms;
